import styled from "styled-components";

export const MainContent = styled.div``;

export const ChildrenContainer = styled.div`
  padding: ${(props) => (props.hasPadding ? "2rem 2rem 0 2rem" : "0")};
  overflow: hidden;
  padding-bottom: 3rem;
`;
